export const container='flex items-center justify-center min-h-screen w-full'
export const card='w-full md:w-3/5 mx-4 rounded-none'
export const buttomDiv= 'my-2 text-center'
export const buttomDivPara =' text-sm font-bold'
export const link ='text-green-700'
export const button ='bg-custom-button-green'

